export default {
  name: 'marking--docType',
};